import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD_fos1eL2Yr8vf0qzVNnHlcG6I1_l8TI0",
  authDomain: "sparta-react-basic-47f86.firebaseapp.com",
  projectId: "sparta-react-basic-47f86",
  storageBucket: "sparta-react-basic-47f86.appspot.com",
  messagingSenderId: "1067099749487",
  appId: "1:1067099749487:web:88716f96c0cb517bf1619a",
  measurementId: "G-T0QLV47P2H"
};
initializeApp(firebaseConfig);

export const db = getFirestore();